import { useEffect } from "react";
import Lenis from "lenis";

let sharedLenis = null;

export function useLenis(options = {}) {
    useEffect(() => {
        if (typeof window === "undefined") return;
        const prefersReduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
        if (prefersReduced) return;

        const lenis = new Lenis({
            duration: 1.15,
            easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
            smoothWheel: true,
            wheelMultiplier: 1,
            touchMultiplier: 1.4,
            ...options,
        });
        sharedLenis = lenis;

        let rafId;
        const raf = (time) => {
            lenis.raf(time);
            rafId = requestAnimationFrame(raf);
        };
        rafId = requestAnimationFrame(raf);

        return () => {
            cancelAnimationFrame(rafId);
            lenis.destroy();
            sharedLenis = null;
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
}

export function scrollToId(id) {
    if (typeof window === "undefined") return;
    const el = document.getElementById(id);
    if (!el) return;
    if (sharedLenis) {
        sharedLenis.scrollTo(el, { offset: -70 });
    } else {
        window.scrollTo({ top: el.offsetTop - 70, behavior: "smooth" });
    }
}
